export default "__VITE_ASSET__9b6daf2e__"